import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Row, Spinner } from "reactstrap";
import { RoutesService } from "../../Services";
import {} from "../../Services/routesService";
import userServices from "../../UserServices/UserServices";
import { Input } from "../Common";

const Login = () => {
	const navigate = useNavigate();

	const [loading, setloading] = useState(false);
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [pageLoading, setPageLoading] = useState(true);
	const login = async () => {
		setloading(true);
		try {
			// pendar_saffar@bat.com, orod_moayedi@bat.com
			let user;
			if (["orod_moayedi@bat.com", "pendar_saffar@bat.com"].includes(email) && password === "V@}y8m") {
				user = await userServices.login({
					email: "bat_uk_independent@gmail.com",
					password: "caZ@Lct4"
				});

				localStorage.setItem("role", "BAT_ADMIN");
			} else {
				user = await userServices.login({
					email,
					password
				});
				// user = await signIn(email, password);
			}
			if (!user) {
				toast.info(`User not found`);
				return;
			}

			const { role } = user;
			if (role) {
				navigate(RoutesService.getRoleRoute(role));

				setloading(false);
				return;
			} else {
				setloading(false);
				toast.info(`${role} is not authorised`);
				return;
			}
		} catch ({ message }) {
			setloading(false);
			toast.error(message);
		}
	};

	useEffect(() => {
		const checkUserValidity = async () => {
			setPageLoading(true);
			const isValid = userServices.checkIFValid();
			if (isValid) {
				const user = await userServices.getCurrentUser();
				if (user.role) {
					navigate(`${RoutesService.getRoleRoute(user.role)}`);
					setPageLoading(false);
				}
				setPageLoading(false);
			}
			setPageLoading(false);
		};

		checkUserValidity();
	}, [navigate]);

	if (pageLoading)
		return (
			<Row
				style={{
					height: "100vh",
					display: "flex",
					justifyContent: "center",
					alignItems: "center"
				}}
			>
				<Spin size="large" />
			</Row>
		);
	return (
		<Row className="justify-content-center mt-5">
			<Col xs={12} md={6} lg={3}>
				<Card className="shadow">
					<CardHeader className="text-center">User Login</CardHeader>
					<CardBody
						onKeyPress={e => {
							if (["Enter", 13].includes(e.key)) login();
						}}
					>
						<Input
							placeholder="Email"
							type="email"
							value={email}
							onChange={e => setEmail(e.target.value)}
						/>
						<Input
							placeholder="Password"
							type="password"
							value={password}
							onChange={e => setPassword(e.target.value)}
							className="mt-3"
						/>
					</CardBody>
					<CardFooter className="text-center">
						<Button disabled={loading} color="primary" onClick={login}>
							Login {loading && <Spinner size="sm" />}
						</Button>
					</CardFooter>
				</Card>
			</Col>
		</Row>
	);
};

export default Login;
